<template>
    <router-view v-slot="{ Component, }">
        <keep-alive
            include="TopicList"
            max="1"
        >
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
